var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2855 2.83685H19.5521C20.9036 2.83685 22 3.94275 22 5.30704V8.60096C22 9.96421 20.9036 11.0711 19.5521 11.0711H16.2855C14.933 11.0711 13.8366 9.96421 13.8366 8.60096V5.30704C13.8366 3.94275 14.933 2.83685 16.2855 2.83685Z",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44892 2.83685H7.71449C9.06703 2.83685 10.1634 3.94275 10.1634 5.30704V8.60096C10.1634 9.96421 9.06703 11.0711 7.71449 11.0711H4.44892C3.09638 11.0711 2 9.96421 2 8.60096V5.30704C2 3.94275 3.09638 2.83685 4.44892 2.83685Z",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44892 14.6025H7.71449C9.06703 14.6025 10.1634 15.7084 10.1634 17.0738V20.3666C10.1634 21.7309 9.06703 22.8368 7.71449 22.8368H4.44892C3.09638 22.8368 2 21.7309 2 20.3666V17.0738C2 15.7084 3.09638 14.6025 4.44892 14.6025Z",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2855 14.6025H19.5521C20.9036 14.6025 22 15.7084 22 17.0738V20.3666C22 21.7309 20.9036 22.8368 19.5521 22.8368H16.2855C14.933 22.8368 13.8366 21.7309 13.8366 20.3666V17.0738C13.8366 15.7084 14.933 14.6025 16.2855 14.6025Z",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.a94b159f7692099a9e84f2a210ca5ec3.svg";
export { ForwardRef as ReactComponent };